import React from 'react'
import { IconProps } from './interfaces/IconProps.interface'

const AlarmFill = (props: IconProps) => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_10115_4847)">
                <path d="M7.9994 14.6669C7.21146 14.6669 6.43125 14.5117 5.7033 14.2102C4.97534 13.9086 4.31391 13.4667 3.75675 12.9095C3.1996 12.3524 2.75765 11.6909 2.45612 10.963C2.15459 10.235 1.9994 9.45481 1.9994 8.66688C1.9994 7.87895 2.15459 7.09873 2.45612 6.37078C2.75765 5.64282 3.1996 4.98139 3.75675 4.42424C4.31391 3.86708 4.97534 3.42513 5.7033 3.1236C6.43125 2.82207 7.21146 2.66688 7.9994 2.66688C9.59069 2.66688 11.1168 3.29902 12.242 4.42424C13.3673 5.54945 13.9994 7.07558 13.9994 8.66688C13.9994 10.2582 13.3673 11.7843 12.242 12.9095C11.1168 14.0347 9.59069 14.6669 7.9994 14.6669ZM8.66606 8.66688V5.33354H7.33273V10.0002H10.6661V8.66688H8.66606ZM1.16406 4.18821L3.52073 1.83154L4.46406 2.77421L2.10606 5.13154L1.16406 4.18821ZM12.4774 1.83154L14.8347 4.18821L13.8921 5.13154L11.5347 2.77421L12.4781 1.83154H12.4774Z" fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_10115_4847">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>

    )
}

export default AlarmFill